import React from "react";

import "./index.css";

import BURunTableContainer from "./BURUNTableContainer";
import { BuRunChargesContextProvider } from "../../../../contexts/bu-RunCharges.context";

function DecoMethods(props) {
  return (
    <div className="deco-container">
      <BURunTableContainer />
    </div>
  );
}

export default DecoMethods;
